// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ld-0";
export var assigneeDetails = "_ld-1";
export var assigneeInfo = "_ld-2";
export var dropdownContainer = "_ld-4";
export var dropdownImage = "_ld-5";
export var editAssigneeInfo = "_ld-3";
export var editAssigneeModalContainer = "_ld-6";
export var hidden = "_ld-8";
export var input = "_ld-7";